function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.8333 23.8333H2.16667V2.16667H11.5556V0L2.73331 0C1.21908 0 0 1.22369 0 2.73331L0 23.2667C0 24.7808 1.22369 26 2.73331 26H23.2667C24.7808 26 26 24.7762 26 23.2667V14.4445H23.8333V23.8333Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.2667 0L18.0554 0V2.16667H22.486L7.17221 17.4805C6.77072 17.882 6.77087 18.5316 7.17177 18.9325C7.57535 19.336 8.22256 19.3331 8.62361 18.9319L23.8333 3.72231V7.94454H26V2.73331C26 1.21922 24.7761 0 23.2667 0Z",
  fill: "currentColor"
});

var SvgIcModalOpen = function SvgIcModalOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcModalOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_modal_open.58f8aa24.svg";
export { ForwardRef as ReactComponent };